'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  ', '\n  justify-content: ', ';\n  span + span {\n    margin-left: 4px;\n  }\n'], ['\n  position: relative;\n  ', '\n  justify-content: ', ';\n  span + span {\n    margin-left: 4px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin-bottom: 12px;\n  margin-top: ', ';\n'], ['\n  margin-bottom: 12px;\n  margin-top: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n'], ['\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: relative;\n  ', '\n\n  ', ' {\n    ', '\n  }\n\n  > span > span {\n    sup {\n      display: inline-block;\n    }\n  }\n\n  &:hover {\n    ', ' {\n      ', '\n    }\n\n  ', '\n  }\n'], ['\n  position: relative;\n  ', '\n\n  ', ' {\n    ', '\n  }\n\n  > span > span {\n    sup {\n      display: inline-block;\n    }\n  }\n\n  &:hover {\n    ', ' {\n      ', '\n    }\n\n  ', '\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _pclnDesignSystem = require('pcln-design-system');

var _StrikePrice = require('../../molecules/StrikePrice');

var _StrikePrice2 = _interopRequireDefault(_StrikePrice);

var _sizeMap = require('../../../helpers/sizeMap');

var _GenericPrice = require('../../atoms/GenericPrice');

var _GenericPrice2 = _interopRequireDefault(_GenericPrice);

var _Disclaimer = require('../../molecules/Disclaimer');

var _Disclaimer2 = _interopRequireDefault(_Disclaimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var propTypes = {
  disclaimer: _propTypes2.default.shape({
    disclaimerMessage: _propTypes2.default.string,
    disclaimerMessageTitle: _propTypes2.default.string,
    iconName: _propTypes2.default.string,
    isCustomTooltipOpen: _propTypes2.default.bool,
    customTooltip: _propTypes2.default.node,
    hoverStyle: _propTypes2.default.bool
  }),
  priceSize: _propTypes2.default.string,
  strikePriceSize: _propTypes2.default.string,
  price: _propTypes2.default.number,
  strikePrice: _propTypes2.default.number,
  priceColor: _propTypes2.default.string,
  strikePriceColor: _propTypes2.default.string,
  strikeColor: _propTypes2.default.string,
  toFixDecimal: _propTypes2.default.number,
  currencySymbol: _propTypes2.default.string,
  topText: _propTypes2.default.string,
  topTextColor: _propTypes2.default.string,
  priceType: _propTypes2.default.node,
  priceTypeColor: _propTypes2.default.string,
  priceIcon: _propTypes2.default.string,
  currencyAutoId: _propTypes2.default.string,
  alignItems: _propTypes2.default.string,
  hoverDisclaimer: _propTypes2.default.bool,
  priceDescription: _propTypes2.default.string,
  boldStrikePrice: _propTypes2.default.bool,
  shouldShowTopTextDisclaimer: _propTypes2.default.bool,
  isPriceOnTop: _propTypes2.default.bool
};

var defaultProps = {
  currencySymbol: '$',
  size: 'large',
  priceColor: 'gray',
  toFixDecimal: 2,
  topTextColor: 'gray',
  priceTypeColor: 'gray',
  alignItems: 'right',
  hoverDisclaimer: false,
  isPriceOnTop: false
};

var SpacedBox = (0, _styledComponents2.default)(_pclnDesignSystem.Box)(_templateObject, function (props) {
  return props.isTooltipFlexAligned && '\n      display: flex;\n    ';
}, function (props) {
  return props.alignItems === 'right' ? 'flex-end' : props.alignItems === 'left' ? 'flex-start' : props.alignItems;
});

SpacedBox.displayName = 'SpacedBox';

var StyledText = (0, _styledComponents2.default)(_pclnDesignSystem.Text)(_templateObject2, function (props) {
  return props.isSmall ? '4px' : '0';
});

var StyledDisclaimer = (0, _styledComponents2.default)(_Disclaimer2.default)(_templateObject3);

var StyledSpan = _styledComponents2.default.span(_templateObject4, function (props) {
  return props.hoverDisclaimer && '\n      cursor: pointer;\n    ';
}, StyledDisclaimer, function (props) {
  return props.hoverDisclaimer && '\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: 0;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity .15s;\n    margin-left: 0;\n    ';
}, StyledDisclaimer, function (props) {
  return props.hoverDisclaimer && '\n        opacity: 1;\n        pointer-events: all;\n        ';
}, function (props) {
  return props.hoverDisclaimer && '\n      > span > span {\n        text-decoration: underline;\n\n        sup {\n          text-decoration: none;\n        }\n      }\n    ';
});

var PriceArea = function PriceArea(_ref) {
  var disclaimer = _ref.disclaimer,
      priceSize = _ref.priceSize,
      strikePriceSize = _ref.strikePriceSize,
      price = _ref.price,
      strikePrice = _ref.strikePrice,
      priceColor = _ref.priceColor,
      strikePriceColor = _ref.strikePriceColor,
      strikeColor = _ref.strikeColor,
      toFixDecimal = _ref.toFixDecimal,
      currencySymbol = _ref.currencySymbol,
      topText = _ref.topText,
      topTextColor = _ref.topTextColor,
      priceType = _ref.priceType,
      priceTypeColor = _ref.priceTypeColor,
      priceIcon = _ref.priceIcon,
      currencyAutoId = _ref.currencyAutoId,
      alignItems = _ref.alignItems,
      hoverDisclaimer = _ref.hoverDisclaimer,
      priceDescription = _ref.priceDescription,
      boldStrikePrice = _ref.boldStrikePrice,
      shouldShowTopTextDisclaimer = _ref.shouldShowTopTextDisclaimer,
      isPriceOnTop = _ref.isPriceOnTop;

  var _ref2 = disclaimer || {},
      customTooltip = _ref2.customTooltip;

  var finalDisclaimer = disclaimer;

  if (hoverDisclaimer && disclaimer && disclaimer.hoverStyle === undefined) {
    finalDisclaimer = Object.assign({}, disclaimer, {
      hoverStyle: true
    });
  }

  var GenericPriceContainer = function GenericPriceContainer() {
    return _react2.default.createElement(_GenericPrice2.default, {
      currencyAutoId: currencyAutoId,
      color: priceColor,
      size: priceSize,
      price: price,
      toFixDecimal: toFixDecimal,
      currencySymbol: currencySymbol,
      priceIcon: priceIcon,
      priceDescription: priceDescription
    });
  };

  return _react2.default.createElement(
    _pclnDesignSystem.Box,
    {
      align: alignItems,
      textAlign: alignItems
    },
    isPriceOnTop && _react2.default.createElement(GenericPriceContainer, null),
    _react2.default.createElement(
      SpacedBox,
      {
        isTooltipFlexAligned: !!customTooltip,
        alignItems: alignItems,
        mt: isPriceOnTop ? '-10px' : 'unset',
        isPriceOnTop: isPriceOnTop },
      topText && _react2.default.createElement(
        _pclnDesignSystem.Text.span,
        { 'data-unit-id': 'TOP_TEXT', color: topTextColor, fontSize: _sizeMap.strikePriceSizeMap[strikePriceSize][0] },
        topText,
        shouldShowTopTextDisclaimer && _react2.default.createElement(StyledDisclaimer, _extends({}, finalDisclaimer, {
          size: strikePriceSize,
          color: strikePriceColor,
          tooltipPositionY: hoverDisclaimer ? 'top' : 'bottom'
        }))
      ),
      strikePrice && strikePrice > 0 && _react2.default.createElement(
        StyledSpan,
        { 'data-unit-id': 'PRICE_WRAPPER', hoverDisclaimer: hoverDisclaimer },
        _react2.default.createElement(_StrikePrice2.default, {
          currencyAutoId: currencyAutoId,
          price: strikePrice,
          size: strikePriceSize,
          color: strikePriceColor,
          toFixDecimal: toFixDecimal,
          currencySymbol: currencySymbol,
          strikeColor: strikeColor,
          bold: boldStrikePrice,
          fontWeight: boldStrikePrice ? 'bold' : 'regular'
        }),
        disclaimer && _react2.default.createElement(StyledDisclaimer, _extends({}, finalDisclaimer, {
          size: strikePriceSize,
          color: strikePriceColor,
          tooltipPositionY: hoverDisclaimer ? 'top' : 'bottom'
        }))
      )
    ),
    !isPriceOnTop && _react2.default.createElement(GenericPriceContainer, null),
    priceType && _react2.default.createElement(
      StyledText,
      {
        isSmall: priceSize === 'small',
        color: priceTypeColor,
        fontSize: _sizeMap.priceTypeSizeMap[priceSize] },
      priceType
    )
  );
};

PriceArea.propTypes = propTypes;
PriceArea.defaultProps = defaultProps;

exports.default = PriceArea;